import { usePermify } from "@permify/react-role"
import { useNavigate } from "react-router-dom"

export const useAuthorization = ({ redirection }) => {
  const { isAuthorized } = usePermify()
  const navigate = useNavigate()

  const hasAccess = async (action) => {
    const canUser = await isAuthorized(null, action)
    if (redirection.enable && !canUser) {
      navigate('/')
    }
    return canUser
  }

  return {
    hasAccess
  }

}

useAuthorization.defaultProps = {
  redirection: {
    to: '/',
    enable: false
  }
}
